import { BellOutlined, EyeOutlined } from "@ant-design/icons";
import { WorkerBlock, WorkerIcon } from "src/containers/workers/ListWorkers/ListWorkers.styles";
import { EditIcon } from "src/icons";
import React from "react";
import { useHistory } from "react-router-dom";
import { getLocation } from "@src/appV2/redesign/utils/routes";

export function QuickActions({
  isLoggedInUser,
  toggleCredentialsModal,
  toggleNotificationsModal,
  isHigherAccessRole,
  canEditNotifications,
}: {
  isLoggedInUser: boolean;
  toggleCredentialsModal: (event: React.MouseEvent) => void;
  toggleNotificationsModal: (event: React.MouseEvent) => void;
  isHigherAccessRole: boolean;
  canEditNotifications: boolean;
}) {
  const history = useHistory();
  let quickActionButton: React.ReactNode | null = null;

  const handleEditClick = (event: React.MouseEvent) => {
    if (isLoggedInUser) {
      history.push(getLocation("myAccount"));
    } else {
      toggleCredentialsModal(event);
    }
  };

  const handleNotificationClick = (event: React.MouseEvent) => {
    toggleNotificationsModal(event);
  };

  if (isHigherAccessRole || canEditNotifications) {
    quickActionButton = (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
        }}
      >
        {canEditNotifications && (
          <WorkerBlock onClick={handleNotificationClick} data-testid="quick-actions-notification">
            <WorkerIcon>
              <BellOutlined data-testid="edit-notifications-icon" />
            </WorkerIcon>
            Edit notifications
          </WorkerBlock>
        )}

        <WorkerBlock onClick={handleEditClick} data-testid="quick-actions-edit">
          <WorkerIcon>
            <EditIcon data-testid="edit-account-icon" />
          </WorkerIcon>
          Edit account
        </WorkerBlock>
      </div>
    );
  }
  if (isLoggedInUser) {
    quickActionButton = (
      <WorkerBlock onClick={handleEditClick} data-testid="quick-actions-edit">
        <WorkerIcon>
          <EyeOutlined data-testid="my-account-icon" />
        </WorkerIcon>
        View my account
      </WorkerBlock>
    );
  }

  return <span style={{ cursor: "pointer" }}>{quickActionButton}</span>;
}
